export const assignation = {
    assignableLesson: true,
    columnsDashboardWidget: {
        default: ['assigned_node_title', 'start_date', 'assigned_user']
    },
    completionStartDateOnly: ['*'],
    displayNews: {
        default : [],
        trainer: ['createNoAssignmentForLongTimeAgo']
    },
    followedLogBookFields: {
        default: ['group', 'type', 'exoName', 'learner', 'beginDate', 'endDate'],
        learner: []
    },
    formFields : {
        default : ['group', 'workgroup', 'learner', 'start_date', 'assignment_type'],
    },
    genericAssignmentListColumns: {
        trainer: ['checkbox', 'assigned_node_title', 'created', 'assigned_user', 'state', 'buttons'],
        default: ['assigned_node_title', 'created', 'assigned_user', 'state', 'buttons']
    },
    genericAssignmentListFilters: {
        default: ['title', 'group', 'workgroup', 'learner', 'type', 'state'],
        learner: []
    },
    genericAssignmentListShowHours: false,
    genericAssignmentsListCheckDefaultFiltersInUrl: true,
    hasCompletionDate: false,
    hasCompletionTime: false,
    isMultipleActionWithCheckBoxes: true,
    noFilterforAssignmentsWidget: true,
    useNicknameInsteadOfUsername: true,
    assignmentsStateIds: {closed: '3411', assigned: '3410', pending: '5609', valid: '4270'}
};
